
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"15","viewBox":"0 0 20 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"3","rx":"1.5","fill":"white"}}),_c('rect',{attrs:{"y":"6","width":"20","height":"3","rx":"1.5","fill":"white"}}),_c('rect',{attrs:{"y":"12","width":"20","height":"3","rx":"1.5","fill":"white"}})])
          )
        }
      }
    